import * as actionsType from './actionsType';
import axiosInstance from '../../axiosInstance';

export const getFareStart = () => {
    return {
        type: actionsType.GET_FARE_START,
    };
};

export const getFareSuccess = (fare) => {
    return {
        type: actionsType.GET_FARE_SUCCESS,
        fare: fare,
    };
};

export const getFareFail = (error) => {
    return {
        type: actionsType.GET_FARE_FAIL,
        error: error,
    };
};

export const getFare = (rideType, country) => {
    return dispatch => {
        dispatch(getFareStart());
        const data = {
            country: country,
            rideType: rideType
        };
        //console.log(data);
        axiosInstance.post(
            '/get-fares-by-ride-type.php',
            data
        )
            .then(response => {
                if (response.data.success) {
                    dispatch(getFareSuccess(response.data.fares));
                } else {
                    dispatch(getFareFail(response.data.errors))
                }

            })
            .catch(error => {
                //console.log(error);
                dispatch(getFareFail([error.message]))
            });
    };
};

export const setDurationAndDistance = (leg) => {
    return {
        type: actionsType.SET_DURATION_AND_DISTANCE,
        leg: leg
    };
};